/**
 * Convert image file to base64 string
 * Used for storing thumbnails in Firestore (no CORS needed!)
 */
export const imageToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // Remove data URL prefix (data:image/jpeg;base64,)
      const base64String = reader.result.split(',')[1];
      resolve(base64String);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

/**
 * Convert base64 string back to data URL for display
 */
export const base64ToDataUrl = (base64String, mimeType = 'image/jpeg') => {
  return `data:${mimeType};base64,${base64String}`;
};

